module.exports = __webpack_public_path__ + "img/1 (19).eb4a6ef4.png";